import { BaseDataLayer, DataLayerPlanType, PLAN_CODE_MAP, SALE_WITH_AGENT_MAP } from './base';

const baseEventParams = {
  page: '/deceso/datos-personales',
  page_title: 'Deceso - Datos Personales',
  product: 'Seguro Deceso',
  view_type: 'web',
};

const pageViewDataLayer = (plan: DataLayerPlanType, insured: string, withAgent: boolean) => ({
  ...baseEventParams,
  action_type: 'Pageview',
  product_type: plan,
  asegurados: insured,
  venta_asistida: SALE_WITH_AGENT_MAP[withAgent.toString()],
});

const whyClickDataLayer = (plan: DataLayerPlanType, insured: string) => ({
  ...baseEventParams,
  action_type: 'click',
  product_type: plan,
  action: 'Click - ¿Por que?',
  asegurados: insured,
});

const goBackClickDataLayer = (plan: DataLayerPlanType, insured: string) => ({
  ...baseEventParams,
  action_type: 'click',
  product_type: plan,
  action: 'Click - Volver',
  asegurados: insured,
});

export const personalPageView = (planCode: string, insured: number, withAgent: boolean) =>
  BaseDataLayer({
    eventParams: pageViewDataLayer(PLAN_CODE_MAP[planCode], insured.toString(), withAgent),
  });

export const personalWhyClick = (planCode: string, insured: number) =>
  BaseDataLayer({
    eventParams: whyClickDataLayer(PLAN_CODE_MAP[planCode], insured.toString()),
  });

export const personalGoBackClick = (planCode: string, insured: number) =>
  BaseDataLayer({
    eventParams: goBackClickDataLayer(PLAN_CODE_MAP[planCode], insured.toString()),
  });
